var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{attrs:{"id":"bottomBtn"},on:{"click":_vm.goHome}},[_c('img',{attrs:{"src":require("@/assets/images/template/toolbar_home.png")}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }